import { Button, InfoPage } from "@shapr3d/frontend-lib";

import useNavigation from "../hooks/navigation";
import useTranslation from "../hooks/useTranslation";

export const SSOTimeoutErrorPage: React.FC = () => {
  const navigation = useNavigation();
  const { t, m } = useTranslation();

  return (
    <InfoPage
      variant="warning"
      title={t(m.ErrorMessage.SSOSessionTimedOut)}
      primaryCTA={
        <Button onClick={() => navigation.goToSignIn()}>{t(m.ErrorMessage.BackToLogin)}</Button>
      }
    />
  );
};
